module.exports = __webpack_public_path__ + "img/94-Briké Rosé - Bouleau.jpg";